export const IMAGES = {
  heroBackdrop:
    "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/863d07b9c723298221c803e24ed833f3bf2934d8bc70ca6f8c986bbcc683e46f.jpeg",
  heroModel:
    "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/872a98f0c2951f57875c8ac9adf29276d462e3f6a4fb51c7a118f5a70de5ca62.jpeg",
  runwayModel:
    "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/4105955b09263cf262ef0cf22766e5d1e5a6434eedb3d661a6c754fb66f137e8.png",
  photographer:
    "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/6b8338f2b5a828a048e3e914e14616be2c4ff786f1d5ee7c784ff22512dbeec9.png",
  stylist:
    "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/d96139c7f158ddd89fe036a3c37482675be21a1034e0afe33317f8fde0be6060.png",
  designer:
    "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/766e9351aa30cf8e92a4fd8e38d9aeba5070caf125ca660ed117fb8873b8942a.png",
};

export const FOUNDER_IMG =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_talent-showcase-245/artifacts/fvfk9fm7_image_2026-07-22_120910248.png";

export const FACES = [
  "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/5cb130164e50c7c0cd4789838a6e475fa8dbfc728ea553a58a3faac12e32c477.png",
  "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/c817fdf5ba95332f9c18ab8e3e1cfe6e23559a1d19c037f2bc86218067f1a478.png",
  "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/f87113e9811d5e46bb25417040eb0e3576b923608b853fb6cffb4c721a3ed63e.png",
  "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/4ccffce796b5fc6202432c51ec739ecee46ec38efd4e30348cd06dc6d8462222.png",
];

const J = "https://static.prod-images.emergentagent.com/jobs/53ff088b-84d9-4fae-be71-7afe4e50d842/images/";

export const CATALOGUE_IMG = {
  photographerMan: J + "96e077237dbd9b27ccd7b6889b21e9f33c85e0768dee2ec566c6c768d86cfb44.jpeg",
  stylistManPattern: J + "d543917f22fdcc066f8dfdaa26d00fa2497428e50557c198a4a89f2359bf6857.jpeg",
  modelGoldGown: J + "c629a631ccfb6acbc53e50956192904c2f3171585b0a8d2a6c94b29ef29365ed.jpeg",
  maleModelSuit: J + "994b50390fb63ba7295757dfc1d91fa99a845ce60c3bfdf1ad1cc887c62f45e5.jpeg",
  stylistWomanAtelier: J + "1e78356c32b5dec5af1483200cbc8073e0c8459fa547ef1501c235ab6f97d428.jpeg",
};
